export default {
  path: '/user-center',
  component: () => import(/* webpackChunkName: "user" */ '@/views/user/UserCenter.vue'),
  children: [
    {
      path: '/',
      redirect: 'user-info',
    },
    {
      path: 'user-info',
      name: 'user-info',
      component: () => import(/* webpackChunkName: "user" */ '@/views/user/UserInfo.vue'),
    },
  ],
};
